import settings from '../settings.js'

import initIdle from '../helpers/initIdle.js';
import initLogin from '../helpers/initLogin.js'

import initFitnessEvents from '../helpers/initFitnessEvents.js'

import tabsHtml from '../templates/tabs.html'

const $inject = ['$scope', '$rootScope', '$ionicModal', '$timeout', '$interval', '$document', 'common', '$ionicPopup', '$ionicPlatform', '$ionicTabsDelegate', '$ionicHistory', '$state', 'toastr', 'UserService', 'FitnessService', 'Idle']

function AppCtrl(scope, rootScope, ionicModal, timeout, interval, document, common, ionicPopup, ionicPlatform, ionicTabsDelegate, ionicHistory, state, toastr, UserService, FitnessService, Idle) {
    scope.baseUrl = settings.baseUrl;
    scope.FitnessService = FitnessService.fitnessAPI();
    scope.appRootDir = appRootDir;

    rootScope.loginData = UserService.loginData;

    scope.isDebugUser = common.isDebugUser;
    scope.writeToServerErrorLog = common.writeToServerErrorLog;

    scope.settings = settings;

    scope.tabsHtml = tabsHtml;

    common.log("appVersion: " + settings.appVersion, true);

    //Backwards compatibility! Moving from appAuthSecret to appId!
    //This can be removed at some point in the (distant) future.
    const oldLangCode = localStorage.getItem('wiseLang-' + settings.appAuthSecret);
    const oldSettingsData = localStorage.getItem('wise-' + settings.appAuthSecret);

    if (oldLangCode) {
        localStorage.setItem('wiseLang-' + settings.appId, oldLangCode);
        delete localStorage['wiseLang-' + settings.appAuthSecret];
    }

    if (oldSettingsData) {
        localStorage.setItem('wise-' + settings.appId, oldSettingsData);
        delete localStorage['wise-' + settings.appAuthSecret];
    }
    //End backwards compatibility

    //Change language if non-default language stored in localStorage. Default is fi-FI.
    const langCode = localStorage.getItem('wiseLang-'+settings.appId);
        
    if (langCode)
        common.log("Found langCode '" + langCode + "' in localStorage", true);

    UserService.setLanguage((langCode ? langCode : (typeof defaultLangCode !== 'undefined' ? defaultLangCode : 'fi-FI')), true);

    window.ionic.Platform.ready(() => {
        const promises = [
            UserService.getMobileAppSettings()
        ];

        //Get fitness data at start if we don't require login to access fitness
        if (settings.fitnessEnabled && !settings.fitnessRequiresLogin) {
            promises.push(FitnessService.getFitnessData());
            console.log(`[${performance.now()}] Calling FitnessService.getFitnessData() from AppCtrl`);
        }

        Promise.all(promises.map(p => p.catch(() => undefined))).then((response) => {
            if (settings.useLocalFitness) { //Never use session for local
                wiseSessionId = undefined;
            }
            else if (wiseSessionId) { //Using session_id() result acquired via php in index.php
                UserService.user.access_token = wiseSessionId;
                console.log("Using wiseSessionId = '" + wiseSessionId + "' as access_token.");
            }

			//Idle logout
            initIdle(scope, rootScope, toastr, UserService);

            //Use rootScope for scope to allow logout from everywhere
            initLogin(rootScope, state, ionicModal, ionicPopup, common, UserService, FitnessService, Idle, ionicHistory, timeout, document, toastr);

    		//Fitness events
        	initFitnessEvents(scope, state, ionicModal, ionicPopup, interval, UserService, FitnessService);

            const current = ionicHistory.currentView();

            if (current?.stateId !== 'app.fitness') //Already on app.fitness due to (for example) forced PWA refresh
                state.go('app.fitness');
            else 
                scope.$broadcast('appCtrl:fitnessReady');

        }).catch((error) => { //getMobileAppSettings or getFitnessData failed
            console.log("error", error);
            //TODO
        });
    });

    scope.$on('$ionicView.enter', () => {
		//Do we hide tabs? 
        ionicTabsDelegate.showBar(!settings.hideTabs);
    });

    //Handle android backbutton press. Go back towards stateFront or exit if already on stateFront
    if (ionic.Platform.isAndroid()) {
        ionicPlatform.registerBackButtonAction((event) => {
            const current = ionicHistory.currentView();
            const back = ionicHistory.backView();

            if (!back && current.stateId !== settings.stateFront)
                state.go(settings.stateFront);
            else if (current.stateId === settings.stateFront)
                ionic.Platform.exitApp();
            else
                ionicHistory.goBack();
        }, 100);
    }
}

AppCtrl.$inject = $inject

export default AppCtrl